import React from "react";
import styled from "styled-components";
import { colors } from "../../Assets/styles/colors";
import { ThreeDots } from "react-loader-spinner";
import { useTranslate } from '@tolgee/react';
import { ReactComponent as CloseCall } from "../../Assets/icons/calls/closeCall.svg";

const AccessRequestSentPage = ({ meetingTitle, closeMeeting, title, subtitle }) => {
  const { t } = useTranslate();
  return (
    <Container>
      <Container>
        <Title>
          {title || (
            <>
              {t('meeting_onboard.request_to_join_sent')}{" "}
              {meetingTitle}{" "}
              {t('meeting_onboard.request_to_join_sent_2')}
            </>
          )}
        </Title>
        <Subtitle>
          {subtitle || t('meeting_onboard.request_to_join_subtitle')}
        </Subtitle>
        <ThreeDots
          visible={true}
          height="80"
          width="80"
          color={colors.purple}
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      </Container>
      <Container>
        <CloseCallBtn onClick={closeMeeting}>
          <CloseCall />
        </CloseCallBtn>
      </Container>
    </Container>
  );
};

export default AccessRequestSentPage;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  height: 100%;
  padding: 50px 50px;
  align-items: center;
  justify-content: center;
`;
const Title = styled.h3`
  fonst-size: 20px;
  line-height: 24px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  text-align: center;
`;
const Subtitle = styled.p`
  fonst-size: 20px;
  line-height: 24px;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  text-align: center;
`;

const CloseCallBtn = styled.button`
  background: none;
  border: none;
  margin-top: auto;
  cursor: pointer;
`;
